import { enableProdMode, StaticProvider } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AuthClientConfig, provideAuth0 } from '@auth0/auth0-angular';
import { IEnvironmentConfig } from '@sondermind/configuration';
import { AUTH0_SIGNUP_PARAM } from '@sondermind/host-auth';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// eslint-disable-next-line no-restricted-globals
const configUrl = `/assets/config/${location.host}.json`;

fetch(configUrl).then((response) => {
  if (!response.ok) {
    throw new Error(`Could not load config from ${configUrl}`);
  }
  return response.json();
}).then((config: IEnvironmentConfig) => {
  // Create your Auth0 configuration object from the loaded config
  const auth0Config = {
    domain: config.auth0Domain,
    clientId: config.auth0ClientToken,
    useRefreshTokens: true,
    cacheLocation: 'localstorage' as const,
    authorizationParams: {
      redirect_uri: `${config.clientPortalBase}?${AUTH0_SIGNUP_PARAM}=true`,
      audience: config.auth0Audience || 'https://monolith-api.com'
    },
  };

  // Now bootstrap the Angular app with the dynamic Auth0 config:
  platformBrowserDynamic([
    ...(provideAuth0(auth0Config) as StaticProvider[]),
    {
      provide: AuthClientConfig,
      useValue: {
        get: () => auth0Config
      }
    },
  ]).bootstrapModule(AppModule)
    // eslint-disable-next-line no-console
    .catch((err) => console.error(err));
}).catch((err) => {
  // eslint-disable-next-line no-console
  console.error('Error loading configuration in main', err);
});
